import React, {FormEvent, useMemo} from 'react';
import {Box, Button, Grid, Typography} from "@mui/material";
import {TextareaWithLabel} from "../../../com/textareaWithLabel/textareaWithLabel";
import {InputResult} from "./inputResult";

interface Props {
    values: string[];
    addItem: (e: FormEvent<HTMLFormElement>) => void;
    removeItem: (itemValue: string) => void;
    inputValue: string;
    fieldName: string;
    labelGridSizeNumber: number;
    labelCaption: string;
    onChangeInput: (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => void;
    isValid: boolean;
    labelAlign: `start` | `end` | `center`;
    isReadOnly?: boolean;

}

export const InputWithShowingResults: React.FC<Props> = ({
                                                             values,
                                                             addItem,
                                                             inputValue,
                                                             fieldName,
                                                             labelGridSizeNumber,
                                                             labelCaption,
                                                             onChangeInput,
                                                             isValid,
                                                             labelAlign,
                                                             removeItem,
                                                             isReadOnly = false
                                                         }) => {

    const emailsComp = useMemo(() => {
        return values.map((value, index) => {
            return <InputResult key={index} value={value} removeItem={removeItem}/>
        })
    }, [values, removeItem]);

    return (
        <form onSubmit={addItem} style={{width: "100%"}}>
            <Grid container alignItems={isReadOnly ? "baseline" :`center`}
                  columns={12}>
                <TextareaWithLabel
                    fieldName={fieldName}
                    labelGridSizeNumber={labelGridSizeNumber}
                    inputGridSizeNumber={7}
                    valueForInput={isReadOnly ? values.join(", ") : inputValue}
                    labelCaption={labelCaption}
                    isBold={true}
                    maxLength={100}
                    onChangeInput={onChangeInput}
                    isNotValid={!isValid}
                    isRequired={true}
                    labelAlign={labelAlign}
                    readonly={isReadOnly}
                    isNoWrap={!isReadOnly}
                />
                {
                    (!isReadOnly && values.length < 4) &&
                    <Grid item xs ml={"4px"}>
                        <Button
                            disabled={!isValid || inputValue === ""}
                            type="submit"
                            sx={{
                                width: "100%",
                                height: "100%",
                                padding: "5px 0",
                                backgroundColor: "#014780",
                                "&:hover": {
                                    backgroundColor: "#014780CC",
                                },
                                "&:disabled": {
                                    backgroundColor: "#0147804D"
                                }
                            }}
                        >
                            <Typography color={"#ffffff"}>
                                Add
                            </Typography>
                        </Button>
                    </Grid>
                }
            </Grid>
            {
                !isReadOnly &&
                <Grid container mt={"8px"} alignItems={`center`}
                      columns={12}>
                    <Grid item xs={4}></Grid>
                    <Grid item xs>
                        <Box sx={{
                            display: 'flex',
                            columnGap: "4px",
                            rowGap: "4px",
                            flexWrap: "wrap",
                        }}>
                            {emailsComp}
                        </Box>
                    </Grid>
                </Grid>
            }
        </form>
    )
}